import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ProfileMessageDialogModule } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.module';

import { GroupMembershipService } from '@main-client/src/app/core/group-membership.service';

import { ProfileActionComponent } from '@main-client/src/app/profile/profile-action/profile-action.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    ProfileMessageDialogModule,
    RouterModule.forChild([]),
  ],
  declarations: [ProfileActionComponent],
  exports: [ProfileActionComponent],
  providers: [GroupMembershipService],
})
export class ProfileActionModule {}
